// extracted by mini-css-extract-plugin
export default {"actionsContainer":"LUIwioFZkg81G1BIzauv","button":"K0Clh_O_njTsVEIKb27N","passivelyActive":"aJSQ4zwoMjzfXjrbgZnw"};